export default __webpack_public_path__ + "static/media/09.4dbaf211.jpg";